import { ref, computed } from "vue";
import { MstSyouninGroupsService } from "@/service/MstSyouninGroupsService";
import { GroupWithMember } from "@/types/SyouninGroup";
import { useAuthStore } from '@/store/auth';
import OptionConst from '@/const/Option';

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);

  // 自身が承認者である承認グループ情報
  const form = ref<GroupWithMember[]>([]);



  const srv = new MstSyouninGroupsService();

  // ユーザー情報の取得
  const authStore = useAuthStore();
  const user = authStore.user;

  if (user == null) {
    // エラー
    loading.value--;
    isError.value = true;
  } else {
    // 自身が承認者である承認グループ情報を取得する
    srv.getGroupMember(user.user_id, true).then((r: GroupWithMember[] | null) => {
      if (r !== null) {
        loading.value--;
        // 打刻承認の分を代入する
        form.value = r.filter((v: any) => v.syounin_type == OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN);
      } else {
        // エラー
        isError.value = true;
      }
    });
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    form,
    isLoading,
    isError,
  }
}
